// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../common/images/Closeicon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Terms-Limitations-Text-wrapper {
  font-size: 16px;
  text-align: center;
}
.Terms-Limitations-Text-wrapper .modal-content {
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(3, 38, 68, 0.1);
  background-color: #ffffff;
}
.Terms-Limitations-Text-wrapper .modal-content .modal-title {
  color: #032644;
  font-size: 24px;
  font-weight: 900;
  text-align: left;
  padding: 0 20px;
}
.Terms-Limitations-Text-wrapper .modal-dialog .modal-body {
  border: none !important;
  overflow-y: auto;
  max-height: 75vh;
  font-size: 16px;
}
.Terms-Limitations-Text-wrapper .modal-dialog .modal-body p,
.Terms-Limitations-Text-wrapper .modal-dialog .modal-body li {
  text-align: left;
}
.Terms-Limitations-Text-wrapper .modal-dialog .albertson-pharmacy {
  margin: 5px 20px;
  padding: 5px;
  font-weight: 600;
  font-size: 16px;
  color: #4d4d4f;
}
.Terms-Limitations-Text-wrapper .modal-dialog .albertson-authorize {
  list-style: disc;
  padding: 5px;
}
.Terms-Limitations-Text-wrapper .modal-dialog .albertson-contact {
  list-style-type: circle;
  margin: 0px 50px 0px;
}
.Terms-Limitations-Text-wrapper .modal-dialog .albertson-info {
  margin: 0px 15px;
  padding: 5px;
}
.Terms-Limitations-Text-wrapper .modal-dialog .button-close {
  margin: 20px;
}

.btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  opacity: 1;
}

.offer-badge-text-terms {
  margin-top: 50px;
}
.offer-badge-text-terms p {
  margin-bottom: 15px;
}

.modal-header {
  justify-content: flex-end;
  border-bottom: none;
  padding: 0px;
}

.sub-title-disclaimer {
  color: #032644;
  font-size: 28px;
  font-weight: 500;
  text-align: left;
  margin: 10px 0;
  padding: 5px 20px;
}

.header-image {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/IncentiveForm/TermsLimitationsModal/TermsLimitationsModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;AACF;AACE;EACE,mBAAA;EACA,6CAAA;EACA,yBAAA;AACJ;AAAI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAEN;AAEI;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAAN;AAEM;;EAEE,gBAAA;AAAR;AAGI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADN;AAGI;EACE,gBAAA;EACA,YAAA;AADN;AAGI;EACE,uBAAA;EACA,oBAAA;AADN;AAGI;EACE,gBAAA;EACA,YAAA;AADN;AAGI;EACE,YAAA;AADN;;AAKA;EACE,mDAAA;EACA,4BAAA;EACA,UAAA;AAFF;;AAIA;EACE,gBAAA;AADF;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AADF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".Terms-Limitations-Text-wrapper {\n  font-size: 16px;\n  text-align: center;\n\n  .modal-content {\n    border-radius: 20px;\n    box-shadow: 0px 0px 10px rgba(3, 38, 68, 0.1);\n    background-color: #ffffff;\n    .modal-title {\n      color: #032644;\n      font-size: 24px;\n      font-weight: 900;\n      text-align: left;\n      padding: 0 20px;\n    }\n  }\n  .modal-dialog {\n    .modal-body {\n      border: none !important;\n      overflow-y: auto;\n      max-height: calc(100vh * 0.75);\n      font-size: 16px;\n\n      p,\n      li {\n        text-align: left;\n      }\n    }\n    .albertson-pharmacy {\n      margin: 5px 20px;\n      padding: 5px;\n      font-weight: 600;\n      font-size: 16px;\n      color: #4d4d4f;\n    }\n    .albertson-authorize {\n      list-style: disc;\n      padding: 5px;\n    }\n    .albertson-contact {\n      list-style-type: circle;\n      margin: 0px 50px 0px;\n    }\n    .albertson-info {\n      margin: 0px 15px;\n      padding: 5px;\n    }\n    .button-close {\n      margin: 20px;\n    }\n  }\n}\n.btn-close {\n  background: url('../../../common/images/Closeicon.svg');\n  background-repeat: no-repeat;\n  opacity: 1;\n}\n.offer-badge-text-terms {\n  margin-top: 50px;\n  p {\n    margin-bottom: 15px;\n  }\n}\n\n.modal-header {\n  justify-content: flex-end;\n  border-bottom: none;\n  padding: 0px;\n}\n.sub-title-disclaimer {\n  color: #032644;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: left;\n  margin: 10px 0;\n  padding: 5px 20px;\n}\n.header-image {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
